import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import styles from "./News.module.css";

const News = () => {
  const { id: companyId } = useParams();
  const [newsList, setNewsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [openIndex, setOpenIndex] = useState(null); // 현재 열린 뉴스 인덱스

  useEffect(() => {
    if (!companyId) {
      setError("회사 ID가 없습니다.");
      setLoading(false);
      return;
    }

    console.log(`🔥 Firestore에서 ${companyId}의 뉴스 불러오기 시작...`);

    const fetchNews = async () => {
      try {
        const companyRef = doc(db, "companies", companyId);
        const companySnap = await getDoc(companyRef);

        if (companySnap.exists()) {
          const companyData = companySnap.data();
          console.log("📄 Firestore에서 불러온 회사 데이터:", companyData);

          if (companyData.news && Array.isArray(companyData.news)) {
            const sortedNews = companyData.news.sort(
              (a, b) => new Date(b.date) - new Date(a.date)
            );
            setNewsList(sortedNews);
          } else {
            setError("등록된 뉴스가 없습니다.");
          }
        } else {
          setError("회사 정보를 찾을 수 없습니다.");
        }
      } catch (error) {
        console.error("🔥 Firestore에서 뉴스 불러오기 실패:", error);
        setError("뉴스를 불러오는 중 오류 발생");
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, [companyId]);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  if (loading)
    return <h2 className={styles.loading}>⏳ 뉴스 불러오는 중...</h2>;
  if (error) return <h2 className={styles.notFound}>❌ {error}</h2>;

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>News</h2>
      <div className={styles.newsList}>
        {newsList.map((news, index) => (
          <div
            key={index}
            className={`${styles.newsItem} ${
              openIndex === index ? styles.open : ""
            }`}
          >
            {/* 뉴스 제목 클릭 시 내용이 펼쳐지도록 설정 */}
            <div
              className={styles.newsTitle}
              onClick={() => toggleAccordion(index)}
            >
              {news.title}
              <span className={styles.date}>
                {new Date(news.date).toLocaleDateString()}
              </span>
            </div>

            {/* 선택된 뉴스만 내용 표시 */}
            {openIndex === index && (
              <div
                className={styles.newsContent}
                dangerouslySetInnerHTML={{ __html: JSON.parse(news.content) }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default News;
